import React from 'react'
import SlideShow from '../generic/SlideShow'

function WhatWeTeach() {
  const items = [
    { icon: <i className="icon-makeup-effects" />, label: 'Makeup Effects' },
    { icon: <i className="icon-sculpture" />, label: 'Sculpture' },
    { icon: <i className="icon-mechanical" />, label: 'Animatronics' },
    { icon: <i className="icon-puppet-making" />, label: 'Puppet Making' },
    { icon: <i className="icon-painting" />, label: 'Painting' },
    { icon: <i className="icon-filmmaking" />, label: 'Filmmaking' },
    { icon: <i className="icon-design" />, label: 'Design' },
    { icon: <i className="icon-fabrication" />, label: 'Fabrication' },
    { icon: <i className="icon-lab-work" />, label: 'Lab Work' },
    { icon: <i className="icon-mold-making" />, label: 'Mold Making' },
    { icon: <i className="icon-hair-work" />, label: 'Hair Work' },
    { icon: <i className="icon-drawing" />, label: 'Drawing' },
    { icon: <i className="icon-life-casting" />, label: 'Life Casting' },

    { icon: <i className="icon-mask-making" />, label: 'Mask Making' },

    { icon: <i className="icon-electronics" />, label: 'Electronics' },
    {
      icon: <i className="icon-eyes-teeth-nails" />,
      label: 'Eyes Teeth Nails'
    },
    { icon: <i className="icon-model-making" />, label: 'Model Making' }
  ]

  return (
    <div id="WhatWeTeach">
      <SlideShow
        arrows
        dots
        autoPlay
        slidesToShow={6}
        slidesToScroll={1}
        responsive={[
          {
            breakpoint: 1328,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]}
      >
        {items.map((item) => (
          <div
            key={item.label}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            {item.icon}
            <p>{item.label}</p>
          </div>
        ))}
      </SlideShow>
    </div>
  )
}

export default WhatWeTeach
